import { IShowTurnParams } from 'src/models';
import Turn from 'src/components/Turn/Turn';

export default {
    turnComponent: null,

    dispose() {
        if (this.turnComponent) {
            this.turnComponent.dispose();
        }
        this.turnComponent = null;
    },

    show(params: IShowTurnParams) {
        if (!this.turnComponent) {
            this.turnComponent = new Turn({
                source: '<x-turn></x-turn>',
            });
            this.turnComponent.attach(document.body);
        }
        this.turnComponent.show(params);
    },
};
